import { useMutation } from "@tanstack/react-query";
import { request } from "../../utilities/axios-utils";

export const emailQuote = async (accessToken, quoteStageNew) => {
  try {
    const response = await request({
      url: `/emailQuote/${quoteStageNew ? "NEW" : "COMPLETE"}`,
      method: "POST",
      data: null,
      accessToken: accessToken,
    });
    return response;
  } catch (error) {
    console.error("Error with emailQuote:", error);
    throw new Error(error);
  }
};

export const useEmailQuoteMutation = () => {
  return useMutation(({ accessToken, quoteStageNew }) =>
    emailQuote(accessToken, quoteStageNew)
  );
};
